import { Hosts } from '.';

const hosts: Hosts = {
  CTL_AUTHENTICATOR_SERVER: 'https://auth-ctl.csg-dev.lunit.in',
  CTL_DATA_SERVER: 'https://data-ctl.csg-dev.lunit.in',
  CTL_IMAGE_SERVER: 'https://image-ctl.csg-dev.lunit.in',
  CTL_ELASTIC_SEARCH: 'https://lunit.es.asia-northeast1.gcp.cloud.es.io:9243',
};

export default hosts;
